import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_OrderFixedButton = _resolveComponent("OrderFixedButton")!
  const _component_CancelPolicyContent = _resolveComponent("CancelPolicyContent")!
  const _component_ApplicationsCancelDueToInfectionModal = _resolveComponent("ApplicationsCancelDueToInfectionModal")!
  const _component_ApplicationsCancelWarningModal = _resolveComponent("ApplicationsCancelWarningModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      キャンセルポリシー・注意点\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CancelPolicyContent, null, {
      default: _withCtx(() => [
        (_ctx.applicationId)
          ? (_openBlock(), _createBlock(_component_OrderFixedButton, {
              key: 0,
              hasSub: "",
              onClick: _ctx.onClickLastConfirm
            }, {
              sub: _withCtx(() => [
                _createTextVNode("\n            ボタンを押すと上記内容を同意することになります\n          ")
              ]),
              default: _withCtx(() => [
                _createTextVNode("\n          最終確認へ\n          ")
              ], undefined, true),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.willBeOutbreakingInfection && _ctx.beforeWorkerReliability)
      ? (_openBlock(), _createBlock(_component_ApplicationsCancelDueToInfectionModal, {
          key: 0,
          currentWorkerReliability: _ctx.beforeWorkerReliability,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          onClickConfirm: _ctx.onClickConfirmButton,
          onClickClose: _ctx.onClickCloseButton
        }, null, 8, ["currentWorkerReliability", "onClickConfirm", "onClickClose"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (
        !_ctx.willBeOutbreakingInfection &&
          _ctx.afterWorkerReliability &&
          _ctx.beforeWorkerReliability
      )
      ? (_openBlock(), _createBlock(_component_ApplicationsCancelWarningModal, {
          key: 1,
          "will-ban": _ctx.willBan,
          beforeWorkerReliability: _ctx.beforeWorkerReliability,
          afterWorkerReliability: _ctx.afterWorkerReliability,
          "application-id": _ctx.applicationId,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          onClickConfirm: _ctx.onClickConfirmButton,
          onClickClose: _ctx.onClickCloseButton
        }, null, 8, ["will-ban", "beforeWorkerReliability", "afterWorkerReliability", "application-id", "onClickConfirm", "onClickClose"]))
      : _createCommentVNode("", true)
  ]))
}